function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 1rem;\n  width: 1rem;\n  padding-right: 1rem;\n  transition: 'transform .2s ease';\n  transform: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "__control {\n    ", ";\n    height: ", ";\n    box-shadow: none;\n\n    &:hover {\n      ", ";\n    }\n\n    &--is-focused {\n      border-bottom-color: ", ";\n\n      ", "__single-value {\n        color: ", ";\n      }\n\n      &:hover {\n        border-color: ", ";\n        border-bottom-color: ", ";\n      }\n    }\n\n    &--is-disabled {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    ", "\n  }\n\n  ", "__value-container {\n    padding-left: 1rem;\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  ", "__indicator-separator {\n    display: none;\n  }\n\n  ", "__single-value {\n    font-size: 1rem;\n    font-family: ", ";\n    color: ", ";\n  }\n\n  ", "__menu {\n    margin-top: 0;\n    box-shadow: ", ";\n  }\n\n  ", "__option {\n    display: flex;\n    align-items: center;\n    text-align: left;\n    background-color: ", ";\n    font-size: 1rem;\n    font-family: ", ";\n    color: ", ";\n    height: 3rem;\n    padding: 0.5rem 2rem;\n    &:hover {\n      background-color: ", ";\n    }\n    &--is-selected {\n      font-weight: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &.menu__placement--top {\n    ", " {\n      & ", "__menu {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n      }\n      ", "__menu-list {\n        height: calc(100vh - 3rem);\n      }\n    }\n\n    ", " {\n      ", "__menu {\n        bottom: 0;\n        top: auto;\n        margin-bottom: 0;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { from, to } from "../../theme";
var selectPrefix = '.select';

var SelectBaseStyle = function SelectBaseStyle(props) {
  return "\n    border: 0.0625rem solid;\n    border-radius: 0.1875rem;\n    border-color: ".concat(props.theme.variables.colors.platinum, ";\n    border-bottom-color: ").concat(props.theme.variables.colors.midGrey, ";\n");
};

var getDropdownIcon = function getDropdownIcon(props) {
  return props.isDisabled ? props.theme.variables.icons.svg.chevronMInactive : props.theme.variables.icons.svg.chevronM;
};

export var SelectWrapper = styled.div(_templateObject(), to('md'), selectPrefix, selectPrefix, from('md'), selectPrefix);
export var SelectContainer = styled.div(_templateObject2(), selectPrefix, SelectBaseStyle, function (props) {
  return props.isDense ? '2.5rem' : '3.5rem';
}, SelectBaseStyle, function (props) {
  return props.theme.variables.colors.blue;
}, selectPrefix, function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.colors.platinum;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.colors.lightGrey;
}, function (props) {
  return props.theme.variables.colors.midGrey;
}, function (props) {
  return props.hasError ? "border-bottom-color: ".concat(props.theme.variables.colors.red) : '';
}, selectPrefix, selectPrefix, selectPrefix, function (props) {
  return props.theme.variables.typography.primaryFont;
}, function (props) {
  return props.theme.variables.colors.darkGrey;
}, selectPrefix, function (props) {
  return props.theme.variables.shadows.shadow;
}, selectPrefix, function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return props.theme.variables.typography.primaryFont;
}, function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.colors.lightGrey;
}, function (props) {
  return props.theme.variables.fonts.weight.semiBold;
});
export var DropdownIndicatorIcon = styled.div(_templateObject3(), function (props) {
  return getDropdownIcon(props);
}, function (props) {
  return props.isMenuOpen ? 'rotate(180deg)' : null;
});